<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >

            <rkm-form
                ref="Form"
            >

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :max-date="data.form.dataAtual"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeColeta"
                            label="Local de coleta"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.coletaUnidadeId"
                            value-field="unidadeId"
                            default-option-text="Todos"
                            @change="handleUnidadeColeta()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="coletaInfraestruturas"
                            textField="nome"
                            v-model="model.coletaInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="handleUnidadeColeta()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeLaboratorio"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.laboratorioId"
                            default-option-text="Todos"
                            value-field="unidadeId"
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="laboratorioInfraestruturas"
                            textField="nome"
                            v-model="model.laboratorioInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template>
            <rkm-table
                v-if="itemsNotSave"
                :items="itemsNotSave"
                :fields="fields"
                hide-filters
                sort-by="nome"
                hide-pagination
            >

                <template v-slot:custom-foot v-if="itemsNotSave && itemsNotSave.length > 0">
                    <tr>
                        <td class="table-td" :colspan="selectedCols.length + 2">
                            Total
                        </td>
                        <td class="table-td text-center">{{ getTotalQuantidade() }}</td>
                        <td class="table-td text-center">{{ getTotalQuantidadeReagente() }}</td>
                    </tr>
                </template>
            </rkm-table>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        coletaInfraestruturas() {

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorioInfraestruturas() {

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.exameProducao'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                laboratorioId: null,
                laboratorioInfraestruturaId: null,
                exameId: null,
                exameNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            agendamentoExame: [],
            unidadeColeta: [],
            unidadeLaboratorio: [],
            itemsNotSave: [],
            items: [],
            enums: {
                preferenciaNome
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                {
                    key: 'procedimentoCodigo',
                    label: 'Procedimento',
                    class: 'col-min text-center',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'exameNome',
                    label: 'Exame',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'coletaNomeFantasia',
                    label: 'Unidade coleta',
                    sortable: true,
                    disabledColumn: true,
                    valueColumn: 'coletaUnidadeId'
                },
                {
                    key: 'coletaInfraestruturaNome',
                    label: 'Local de atendimento coleta',
                    sortable: true,
                    disabledColumn: true,
                    valueColumn: 'coletaInfraestruturaId'
                },
                {
                    key: 'laboratorioNomeFantasia',
                    label: 'Laboratório',
                    sortable: true,
                    disabledColumn: true,
                    valueColumn: 'laboratorioId'
                },
                {
                    key: 'laboratorioInfraestruturaNome',
                    label: 'Local de atendimento laboratório',
                    sortable: true,
                    disabledColumn: true,
                    valueColumn: 'laboratorioInfraestruturaId'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    class: 'col-min text-center',
                    sortable: true,
                    fixed: true
                },
                {
                    key: 'quantidadeReagente',
                    label: 'Quantidade de reagentes',
                    class: 'col-min text-center',
                    sortable: true,
                    fixed: true
                },

            ],
            selectedCols: [],
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'inicio' || key === 'fim') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.periodo = this.data.form.periodo
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioExameProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioExameProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.model.exameId) {

                data.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (data.coletaUnidadeId) {

                data.coletaUnidadeNome = this.unidadeColeta.find(u => u.unidadeId == data.coletaUnidadeId).nomeFantasia
            }

            if (data.coletaInfraestruturaId) {

                data.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == data.coletaInfraestruturaId).nome
            }

            if (data.laboratorioId) {

                data.laboratorioNome = this.unidadeLaboratorio.find(u => u.unidadeId == data.laboratorioId).nomeFantasia
            }

            if (data.laboratorioInfraestruturaId) {

                data.laboratorioInfraestruturaNome = this.laboratorioInfraestruturas.find(u => u.id == data.laboratorioInfraestruturaId).nome
            }

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        handleLaboratorioInfraestrutura(infraestruturaLaboratorioPrincipal) {

            if (infraestruturaLaboratorioPrincipal.find(u => u.principal === true)) {

                this.model.laboratorioInfraestruturaId = infraestruturaLaboratorioPrincipal.find(u => u.principal === true).id
            }
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        setLaboratorioInfraestrutura() {

            this.model.laboratorioInfraestruturaId = null
        },
        loadFields() {

            this.setLoading()

            this.setListagem()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeColeta(data.model.unidades)
                    this.loadLaboratorio(data.model.laboratorios)
                    this.loadExame(data.model.exames)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeColeta(agendamento) {

            const coleta = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.coletaUnidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.coletaInfraestruturaId).principal

                const coletaInserida = coleta.find(u => u.unidadeId
                    === infraestrutura.coletaUnidadeId)

                if (coletaInserida) {

                    let verifyUnidade = coletaInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.coletaInfraestruturaId)

                    if (!verifyUnidade) {

                        coletaInserida.infraestruturas.push({

                            id: infraestrutura.coletaInfraestruturaId,
                            nome: infraestrutura.coletaUnidadeNome,
                            principal: principal,
                        })
                    }

                } else {

                    coleta.push({

                        unidadeId: infraestrutura.coletaUnidadeId,
                        nomeFantasia: infraestrutura.coletaUnidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.coletaInfraestruturaId,
                                nome: infraestrutura.coletaInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeColeta = coleta
        },
        loadLaboratorio(agendamento) {

            const laboratorio = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.laboratorioId).infraestruturas.find(u => u.id
                        === infraestrutura.laboratorioInfraestruturaId).principal

                const laboratorioInserida = laboratorio.find(u => u.unidadeId
                    === infraestrutura.laboratorioId)

                if (laboratorioInserida) {

                    let verifyUnidade = laboratorioInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.laboratorioInfraestruturaId)

                    if (!verifyUnidade) {

                        laboratorioInserida.infraestruturas.push({

                            id: infraestrutura.laboratorioInfraestruturaId,
                            nome: infraestrutura.laboratorioInfraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    laboratorio.push({

                        unidadeId: infraestrutura.laboratorioId,
                        nomeFantasia: infraestrutura.unidadeLaboratorioNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.laboratorioInfraestruturaId,
                                nome: infraestrutura.laboratorioInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeLaboratorio = laboratorio
        },
        loadExame(agendamento) {

            const exameCadastrado = []

            agendamento.map(exames => {

                    const exameInserido = exameCadastrado.find(u => u.id == exames.id)

                    if (!exameInserido) {

                        exameCadastrado.push({

                            id: exames.id,
                            nome: exames.nome,
                        })
                    }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado

            let exameSelecionado = this.agendamentoExame.find(u => u.id == this.model.exameId)

            if (!exameSelecionado) {

                this.model.exameId = null
            }
        },
        getTotalQuantidade() {

            return this.itemsNotSave.reduce((sum, element) => {

                    sum = sum + Number(element.quantidade);

                return sum;
            },0)
        },
        getTotalQuantidadeReagente() {

            return this.itemsNotSave.reduce((sum, element) => {

                if (element.quantidadeReagente) {

                    sum = sum + Number(element.quantidadeReagente);
                }

                return sum;
            },0)
        },
        handleUnidadeColeta() {

            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleExame() {

            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.coletaUnidadeId'() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                this.handleColetaInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.laboratorioId'() {

            this.setLaboratorioInfraestrutura()

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                this.handleLaboratorioInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
.coleta {
    background: #e9e9e9;
}
</style>